export default class ShowMoreChildren {
  constructor(buttonClass) {
    this.buttons = document.getElementsByClassName(buttonClass);
    this.init();
  }

  showMoreRows(ev) {
    ev.preventDefault();
    [...ev.target.parentElement.children].forEach((item) => (
      item.classList.remove('hidden')
    ));
    ev.target.classList.add('hidden');
  }

  init() {
    [...this.buttons].forEach(
      (button) => button.addEventListener('click', this.showMoreRows)
    );
  }
}
